module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dof-checkbox-list weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, _vm._l((_vm.list), function(item, i) {
    return _c('dof-checkbox', _vm._b({
      key: i,
      attrs: {
        "hasTopBorder": i === 0 && _vm.needShowTopBorder ? true : false,
        "itemImg": item.itemImg,
        "hasSubBottomBorder": _vm._isColmo ? true : _vm.hasBorder,
        "data-evt-dofCheckBoxItemChecked": ""
      },
      on: {
        "dofCheckBoxItemChecked": _vm.dofCheckBoxItemChecked
      }
    }, 'dof-checkbox', item, false))
  }), 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-dd309bba", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd309bba","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-checkbox-list/index.vue
// module id = 673
// module chunks = 0 1